import { createFileRoute } from '@tanstack/react-router'
import { Activity } from 'lucide-react'
import { z } from 'zod'
import { RuntimeScreen } from '@/screens/investigate/SCR-017-runtime'

export const Route = createFileRoute('/_app/w/$ws/runtime')({
  staticData: { screen: { id: 'SCR-017', title: 'Runtime graph', group: 'Investigate', perm: 'trace.read', order: 8, description: 'Agent spans and hand-offs, from your agents’ OpenTelemetry traces.', icon: Activity } },
  validateSearch: z.object({
    trace: z.string().regex(/^[0-9a-f]{32}$/i).optional().catch(undefined),
    limit: z.coerce.number().int().min(10).max(500).optional().catch(undefined),
  }),
  component: RuntimeScreen,
})
